export const ListingType = {
  SEARCH: 'SEARCH',
  ORGANIZATION_AUCTIONS: 'ORGANIZATION_AUCTIONS',
  ORGANIZATION_BIDS: 'ORGANIZATION_BIDS',
};
